<script>
export default {
  data() {
    return {
      formValue: {},
      customErrorMessage: {},
      componentsConfig: [
        {
          componentName: 'BInputWrapper',
          // uiSchemaMatcher: { uiType: 'BInputWrapper' },
          matcher: { type: 'input' },
          // eventName: 'changeInput',
          props: (propName, schema, uiSchema) => {
            // console.log('propName', propName);
            // console.log('schema', schema);
            // console.log('uiSchema', uiSchema);
            return {
              'full-width': true,
              class: 'sb2-bordered sb2-hoverable sb2-focusable',
              placeholder: schema.placeholder,
              validators: schema.validators,
              schema,
            };
          },
        },
        {
          componentName: 'SBTextareaWrapper',
          // uiSchemaMatcher: { uiType: 'SBTextareaWrapper' },
          matcher: { type: 'textarea' },
          // eventName: 'changeInput',
          props: (propName, schema, uiSchema) => {
            return {
              'full-width': true,
              class: 'sb2-bordered sb2-hoverable sb2-focusable',
              placeholder: schema.placeholder,
              validators: schema.validators,
              schema,
            };
          },
        },
        {
          componentName: 'SBDropdownWrapper',
          // uiSchemaMatcher: { uiType: 'SBDropdownWrapper' },
          matcher: { type: 'dropdown' },
          // eventName: 'changeInput',
          props: (propName, schema, uiSchema) => {
            // console.log('DROPDOWN');
            // console.log(uiSchema);
            return {
              class: 'sb2-bordered sb2-hoverable sb2-focusable',
              placeholder: schema.placeholder,
              validators: schema.validators,
              required: schema.validators ? schema.validators.split('|').includes('required') : false,
              schema,
              // 'ui-schema': uiSchema,
            };
          },
        },
        {
          componentName: 'NMBRButtonsWrapper',
          // uiSchemaMatcher: { uiType: 'NMBRButtonsWrapper' },
          matcher: { type: 'message-buttons' },
          props: (propName, schema, uiSchema) => {
            return {
              'full-width': true,
              class: 'sb2-bordered sb2-hoverable sb2-focusable',
              placeholder: schema.placeholder,
              validators: schema.validators,
              schema,
            };
          },
        },
        {
          componentName: 'DividerWrapper',
          // uiSchemaMatcher: { uiType: 'DividerWrapper' },
          matcher: { type: 'dividerFull' },
          props: (propName, schema, uiSchema) => {
            return {
              'full-width': true,
              schema,
            };
          },
        },
        {
          componentName: 'DividerWrapper',
          // uiSchemaMatcher: { uiType: 'DividerWrapper' },           // IMPORTANT: maybe uiSchema is not needed
          matcher: { type: 'divider' },
          props: (propName, schema, uiSchema) => {
            return {
              'full-width': false,
              schema,
            };
          },
        },
        {
          componentName: 'SkeletonWrapper',
          // uiSchemaMatcher: { uiType: 'DividerWrapper' },           // IMPORTANT: maybe uiSchema is not needed
          matcher: { type: 'skeleton' },
          props: (propName, schema, uiSchema) => {
            return {
              'full-width': false,
              schema,
            };
          },
        },
        {
          componentName: 'NMBRActionsWrapper',
          matcher: { type: 'action-buttons' },
          props: (propName, schema, uiSchema) => {
            return {
              class: 'sb2-bordered sb2-hoverable sb2-focusable',
              validators: schema.validators,
              schema,
            };
          },
        },
        {
          componentName: 'FileInputWrapper',
          matcher: { type: 'file-input-wrapper' },
          props: (propName, schema, uiSchema) => {
            return {
              class: 'sb2-bordered sb2-hoverable sb2-focusable',
              validators: schema.validators,
              schema,
            };
          },
        },
        {
          componentName: 'UrlInputWrapper',
          matcher: { type: 'url-input-wrapper' },
          props: (propName, schema, uiSchema) => {
            return {
              propName,
              class: 'sb2-bordered sb2-hoverable sb2-focusable',
              validators: schema.validators,
              schema,
            };
          },
        },
        {
          componentName: 'NMBRRadioWrapper',
          matcher: { type: 'radio-NMBR' },
          props: (propName, schema, uiSchema) => {
            return {
              validators: schema.validators,
              schema,
            };
          },
        },
        {
          componentName: 'DurationWrapper',
          matcher: { type: 'duration' },
          props: (propName, schema, uiSchema) => {
            return {
              validators: schema.validators,
              schema,
              propName,
              minSeconds: schema.minSeconds || null,
              minSecondsMessage: schema.minSecondsMessage || null,
              maxSeconds: schema.maxSeconds || 30 * 24 * 60 * 60, // 30 days
              maxSecondsMessage: schema.maxSecondsMessage || 'Retrigger period exceeds maximum allowed time.',
            };
          },
        },
        {
          componentName: 'CustomValidator',
          matcher: { type: 'custom-validator' },
          props: (propName, schema, uiSchema) => {
            return {
              validators: schema.validators,
              schema,
            };
          },
        },
        {
          componentName: 'QuestionsWrapper',
          matcher: { type: 'questions' },
          props: (propName, schema, uiSchema) => {
            return {
              class: 'sb2-bordered sb2-hoverable sb2-focusable',
              validators: schema.validators,
              schema,
            };
          },
        },
        {
          componentName: 'QuestionsListModalWrapper',
          matcher: { type: 'questions-list-modal' },
          props: (propName, schema, uiSchema) => {
            return {
              class: 'sb2-bordered sb2-hoverable sb2-focusable',
              validators: schema.validators,
              schema,
            };
          },
        },
        {
          componentName: 'InputListWrapper',
          matcher: { type: 'input-list' },
          props: (propName, schema, uiSchema) => {
            return {
              class: 'sb2-bordered sb2-hoverable sb2-focusable',
              validators: schema.validators,
              placeholder: schema.placeholder,
              schema,
            };
          },
        },
        {
          componentName: 'ConversationWrapper',
          matcher: { type: 'conversation' },
          props: (propName, schema, uiSchema) => {
            return {
              class: 'sb2-bordered sb2-hoverable sb2-focusable',
              validators: schema.validators,
              placeholder: schema.placeholder,
              schema,
            };
          },
        },
        {
          componentName: 'WarningBubble',
          matcher: { type: 'warning' },
          props: (propName, schema) => ({
            class: 'sb2-bordered sb2-hoverable sb2-focusable',
            message: schema.message,
            icon: schema.icon,
          }),
        },
        {
          componentName: 'RemoteDataForm',
          matcher: { type: 'remoteData' },
          props: (propName, schema, uiSchema) => {
            return {
              class: 'sb2-bordered sb2-hoverable sb2-focusable',
              validators: schema.validators,
              schema,
            };
          },
        },
        {
          componentName: 'WidgetSources',
          matcher: { type: 'widgetSources' },
          props: (propName, schema, uiSchema) => {
            return {
              class: 'sb2-bordered sb2-hoverable sb2-focusable',
              validators: schema.validators,
              schema,
            };
          },
        },
      ],
    };
  },
  computed: {
    wrapperComponentConfig() {
      return {
        componentName: 'SBCustomWrapperJSONForms',
        props: (propName, schema, uiSchema) => ({
          title: schema.title || schema.title === '' ? schema.title : null, //propName,
          required: schema.validators ? schema.validators.split('|').includes('required') : false,
          disabled: uiSchema && uiSchema.disabled,
          errorMessage: schema.errorMessage,
          vertical: schema.type === 'object' || schema.type === 'array',
          schema,
          propName,
          customErrorMessage: this.customErrorMessage,
        }),
      };
    },
    schema() {
      // console.log('schemaBlueprint PROC 222', this.schemaBP);
      // const schema = { ...schemaBP };

      // const schema = this.formValue ? this.filterSchema(JSON.parse(JSON.stringify(this.data.jsonSchema))) : {};
      let schema = this.formValue ? this.filterSchema(JSON.parse(JSON.stringify(this.schemaBP))) : {};
      schema = this.filterCustomValidator(schema);

      // console.log('schema PROC', schema);
      return schema;
    },
    uiSchema() {
      const uiSchema = {
        properties: {},
      };
      uiSchema.properties = {
        ...uiSchema.properties,
        // ...this.proccessUiSchema(this.schema).properties,
      };
      // console.log('uiSchema', uiSchema);
      return uiSchema;
    },
    schemaValid() {
      return !Object.keys(this.formValue).some((component) => {
        // First check if it has 'Value' key. If it doesn't have it then this is a subform and it needs to be passed to the checkData function recursively.
        if (this.formValue[component].valid === undefined) {
          if (!this.checkFormValid(this.formValue[component])) {
            return true;
          }
          return false;
        }
        if (this.formValue[component] && this.formValue[component].valid === false) {
          return true;
        }
        return false;
      });
    },
  },
  methods: {
    checkValue(condition = 'one', check = [], parentKey = '') {
      // If all the check fields are not dirty then return true
      const hasDirtyChecks = check.some((c) => {
        const targetKey = parentKey ? `${parentKey}.${c}` : c;
        const cField = this.getObjectCopyByPath(this.value, targetKey);
        return cField && cField.dirty;
      });
      if (!hasDirtyChecks) {
        return true;
      }

      let pass = false;
      // console.log('bla');

      // const targetKey = parentKey ? `${parentKey}.${input}` : input;
      const checks = {};

      check.forEach((c) => {
        const targetKey = parentKey ? `${parentKey}.${c}` : c;
        checks[c] = this.getObjectCopyByPath(this.value, targetKey);
      });

      if (condition === 'one') {
        Object.keys(checks).some((c) => {
          if (checks[c] && checks[c].hasData && checks[c].valid) {
            // console.log('checks SET to empty');
            pass = true;
            return true;
          }
          // console.log('checks false');
          return false;
        });
      }

      // console.log('checks message', pass);
      return pass;
    },

    /**
     * Special method for custom validator to remove it from schema if not needed.
     * Fields tested with custom validator must have a 'dirty' value in the data object.
     */
    filterCustomValidator(schema, parentKey = '') {
      if (!schema.properties) return schema;
      Object.keys(schema.properties).forEach((key) => {
        const valueKey = parentKey ? `${parentKey}.${key}` : key;
        const prop = schema.properties[key];
        if (prop.type === 'custom-validator') {
          prop.value = this.checkValue(prop.condition, prop.check, parentKey) ? '' : prop.message;
          // console.log('checks - ', prop.value, !prop.value);
          if (
            !prop.value
          ) {
            // console.group('checks DELETE PROC');
            // console.log(targetValue);
            // console.log(targetValue, value);
            // console.groupEnd();
            delete schema.properties[key];
            // console.log('DELETE', key);
            // console.log('parentKey', parentKey);
            if (parentKey) {
              const targetValue = this.getObjectCopyByPath(this.value, parentKey);
              // console.log('targetValue', targetValue);
              if (targetValue) {
                delete targetValue[key];
              }
              this.value[parentKey] = targetValue;
            } else {
              // console.log('NO parentKey', this.value);
              delete this.value[key];
            }
            // delete this.value[key];                         // TODO : valueKey - FIX THIS to use path
          }
        }
        if (schema.properties && schema.properties[key] && prop.type === 'object') {
          schema.properties[key] = this.filterCustomValidator(prop, valueKey);
        }
      });
      return schema;
    },
    filterSchema(schema, parentKey = '') {
      if (!schema.properties) return schema;
      // console.log('---------- filterSchema', schema);
      // console.log('filterSchema', schema.properties);
      // const filteredSchema = {
      //   ...schema,
      //   properties: {},
      // };
      // const schemaCopy = { ...schema };
      Object.keys(schema.properties).forEach((key) => {
        const valueKey = parentKey ? `${parentKey}.${key}` : key;
        const prop = schema.properties[key];
        if (prop.showIf) {   // TODO : showIf should be an array of objects
          const { input, value } = prop.showIf;
          const targetKey = parentKey ? `${parentKey}.${input}` : input;
          // console.log('TrgetKey', targetKey);
          const targetValue = this.getObjectCopyByPath(this.formValue, targetKey);
          // console.log('targetValue', targetValue);
          // console.log('test PROC', targetValue, value);
          if (
            !targetValue ||
            !targetValue.data ||
            (
              targetValue.data.value !== value &&
              (!Array.isArray(value) || !value.includes(targetValue.data.value))
            )
          ) {
            // console.group('DELETE PROC');
            // console.log(targetValue);
            // console.log(targetValue, value);
            // console.groupEnd();
            delete schema.properties[key];
            delete this.formValue[key];                         // TODO : valueKey - FIX THIS to use path
          } else if (!schema.properties[key].color && targetValue.data.color) {
            // const controlField = this.findFieldInSchema(schemaBP, input);
            // console.log('controlField PROC', this.value[input].data.color);
            schema.properties[key].color = targetValue.data.color;
          } else if (schema.properties[key].color && schema.properties[key].color === 'default') {
            delete schema.properties[key].color;
          }
        }
        if (schema.properties && schema.properties[key] && prop.type === 'object') {
          schema.properties[key] = this.filterSchema(prop, valueKey);
        }
      });
      return schema;
    },
    findFieldInSchema(schema, key) {
      if (!schema.properties) return null;
      if (schema.properties && schema.properties[key]) {
        return schema.properties[key];
      }
      Object.keys(schema.properties).forEach((prop) => {
        if (schema.properties[prop].type === 'object') {
          return this.findFieldInSchema(schema.properties[prop], key);
        }
        return null;
      });
      return null;
    },
    initDefault(v) {
      // console.log('initDefault', v);
      // console.log('initDefault 2', this.value);

      // if (this.value) {
      //   this.formValue = this.value;
      // } else {
      // }
      this.formValue = v;
    },
    runCustomValidators(form, force = false) {
      Object.keys(form).forEach((component) => {
        // console.trace('runCustomValidators', component);
        if (form[component] && form[component].validOneOf) {
          // check all the values in the validOneOf array
          const oneIsValid = form[component].validOneOf.some(v => form[v] && form[v].valid);
          const dirty = form[component].validOneOf.some(v => form[v] && form[v].dirty);
          if (!oneIsValid) {
            if (form[component].validOneOfMessage) {
              this.$set(this.customErrorMessage, component, {
                message: form[component].validOneOfMessage,
                dirty: dirty || force,
              });
            }
          } else {
            // must delete all of them
            Object.keys(this.customErrorMessage).forEach((key) => {
              if (form[key].validOneOf.includes(key)) {
                delete this.customErrorMessage[key];
              }
            });
          }
        }
        if (form[component] && form[component].valid === undefined) {
          // console.log('Inner form');
          this.runCustomValidators(form[component], force);
        }
      });
    },


    // TODO do we need this ???
    proccessUiSchema(schema) {
      // console.log('1');
      // console.log(schema);
      const uiSchema = {
        properties: {},
      };
      if (!schema.properties) return uiSchema;
      // console.log('2');
      Object.keys(schema.properties).forEach((prop) => {
        switch (schema.properties[prop].type) {
          case 'input':
            // console.log('input');
            // console.log(prop);
            uiSchema.properties[prop] = {
              uiType: 'BInputWrapper',
            };
            break;
          case 'textarea':
            uiSchema.properties[prop] = {
              uiType: 'SBTextareaWrapper',
            };
            break;
          case 'dropdown':
            uiSchema.properties[prop] = {
              uiType: 'SBDropdownWrapper',
            };
            break;
          case 'message-buttons':
            uiSchema.properties[prop] = {
              uiType: 'NMBRButtonsWrapper',
            };
            break;
          // case 'dividerFull':
          //   uiSchema.properties[prop] = {
          //     uiType: 'DividerWrapper',
          //   };
          //   break;
          case 'number':
            // uiSchema.properties[prop] = {
            //   uiType: 'b-input',
            // };
            break;
          case 'boolean':
            // uiSchema.properties[prop] = {
            //   uiType: 'b-input',
            // };
            break;
          case 'object':
            // uiSchema.properties[prop] = {
            uiSchema.properties[prop] = {
              properties: {
                ...this.proccessUiSchema(schema.properties[prop]).properties,
              },
            };
            // };
            break;
          default:
            // console.log('default');
            // console.log(prop);
            // uiSchema.properties[prop] = {
            //   uiType: 'BInputWrapper',
            // };
            break;
        }
      });
      // console.log('returning uiSchema', uiSchema);
      return uiSchema;
    },
    /** Forces validation on current step by emitting the message to all the step components. */
    forceValidation() {
      this.runCustomValidators(this.formValue, true);
      Object.keys(this.formValue).forEach((component) => {
        if (this.formValue[component] && !this.formValue[component].valid) {
          this.$eventBus.$emit(`validate-${this.stepID}`);
        }
      });
    },
    checkFormValid(form) {
      return !Object.keys(form).some((component) => {
        // First check if it has 'Value' key. If it doesn't have it then this is a subform and it needs to be passed to the checkData function recursively.
        if (!form[component] || this.emptyObject(form[component])) return true;
        if (form[component].validOneOf) {
          return !!this.customErrorMessage[component];
        }
        if (form[component].valid === undefined) {
          if (!this.checkFormValid(form[component])) {
            return true;
          }
          return false;
        }
        if (form[component] && form[component].valid === false) {
          return true;
        }
        return false;
      });
    },
    checkData() {
      const formValid = this.checkFormValid(this.formValue);
      this.$emit('input', {
        valid: formValid,
        name: this.dat.stepName,
        data: this.formValue,
      });
    },
  },
};
</script>


<!--

  TODO: validOneOf - we allready have this functionality in the custom validator but it was not triggering correctly so if will be needed fix it and use it after the fix.

{
  ...(rest of element values),  
  "validOneOf": [
    "customerSupportFileInput",
    "customerSupportUrlInput"
  ],
  "validOneOfMessage": "Add at least one data source.",
}

-->
